import { useEffect } from "react";
import { syncCollectorPresentation } from "./collectorPresentation";

import {
  readSharedThemePreference,
  setSharedThemePreference,
  subscribeSharedTheme,
  syncSharedThemePreference,
  type ThemePreference,
} from "../ui/theme";

const AUTHENTICATED_PREFIXES = [
  "/admin", "/client", "/organization", "/analyst", "/senior", "/setup", "/change-password",
] as const;

export function isAuthenticatedThemeSurface(path: string): boolean {
  return AUTHENTICATED_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

export function readStoredWorkspaceTheme(): ThemePreference {
  return readSharedThemePreference();
}

export function applyWorkspaceTheme(preference: ThemePreference): void {
  setSharedThemePreference(preference);
}

export function WorkspaceThemeRuntime({ path }: { path: string }) {
  useEffect(() => path === "/client" || path.startsWith("/client/") ? syncCollectorPresentation() : undefined, [path]);
  useEffect(() => {
    if (!isAuthenticatedThemeSurface(path)) return;

    const sync = (preference = readSharedThemePreference()) => {
      syncSharedThemePreference(preference);
    };
    sync();
    const unsubscribe = subscribeSharedTheme(sync);

    if (typeof window.matchMedia !== "function") return unsubscribe;
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const syncSystem = () => {
      if (readSharedThemePreference() === "system") syncSharedThemePreference("system");
    };
    media.addEventListener?.("change", syncSystem);
    return () => {
      unsubscribe();
      media.removeEventListener?.("change", syncSystem);
    };
  }, [path]);
  return null;
}
